<template>
  <!-- 67% style="width:780px;height:560px" -->
  <div class="flex_div">
    <boxTitleMoudle :title="titleName" class="worksite" style="position: relative" :left="'0px'">
      <section style="width: 100%; height: 100%" v-if="!isShowVedio">
        <div style="height: 5%" class="m-t-10">
          <div class="flex_bet">
            <div class="tab_li" style="width: 300px; padding: 0 0 0 10px; line-height: 30px">
              <span
                :class="index == tabIndex ? 'active' : ''"
                v-for="(item, index) in tab_li"
                @click="changeTab(index)"
                :key="index"
              >{{ item }}</span>
              <!-- <span>项目预览</span>
            <span>宣传快讯</span>
              <span>通知公告</span>-->
            </div>
            <div
              class="tab_li"
              style="width: calc(100% - 320px); display: flex; padding: 0px;justify-content: space-around"
            >
              <div style="margin-right: 18px">
                <b style="margin-right: 10px">安全施工天数</b>

                <span style="color: #abffbf; margin-right: 6px">
                  <span
                    class="work_day box-count"
                    style="margin-right: 5px"
                    v-for="(item, ind) in hasNumber"
                    :key="ind"
                  >{{ item }}</span>
                  <b class="work_day">天</b>
                </span>
              </div>
              <div>
                <b style="margin-right: 6px">进度倒计时</b>
                <span style="color: #ffd1ab; margin-right: 6px">
                  <span
                    class="work_day box-count"
                    style="margin-right: 5px"
                    v-for="(item, ind) in residueNumber"
                    :key="ind"
                  >{{ item }}</span>
                  <b class="online">天</b>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          style="height: 95%"
          class="m-t-10"
          v-on:mouseover="addActive($event)"
          v-on:mouseout="removeActive($event)"
        >
          <section style="height: 100%" v-if="tabIndex == 0">
            <div class="banner" style="height: 70%">
              <img style="height: 100%" src="./img/banner.png" alt />
              <div class="monitor monitor_1" @click="isShowVedio = true">
                <img style="width: 33px" src="./img/movie.png" alt class="movie" />
                <img style="width: 80px" src="./img/movie_status.png" alt class="movie_status" />
                <img style="width: 72px; height: 90px" src="./img/movieLine.png" alt />
              </div>
              <div class="monitor monitor_2" @click="isShowVedio = true">
                <img style="width: 33px" src="./img/movie.png" alt class="movie" />
                <img style="width: 80px" src="./img/movie_status.png" alt class="movie_status" />
                <img style="width: 72px; height: 90px" src="./img/movieLine.png" alt />
              </div>
              <div class="monitor monitor_3" @click="isShowVedio = true">
                <img style="width: 33px" src="./img/movie.png" alt class="movie" />
                <img style="width: 80px" src="./img/movie_status.png" alt class="movie_status" />
                <img style="width: 72px; height: 90px" src="./img/movieLine.png" alt />
              </div>
              <!-- <div class="monitor monitor_4">
                <img style="width:64px" src="./img/movie.png" alt class="movie" />
                <img
                  style="width:124px"
                  src="./img/movie_status.png"
                  alt
                  class="movie_status"
                />
                <img style="width:72px;height:90px" src="./img/movieLine.png" alt />
              </div>-->
            </div>
            <div class="process" style="height: 27%; width: 100%">
              <!-- <img class="title" src="./img/process.png" alt="" /> -->
              <div
                class="flex_bet"
                style="
                  padding-left: 14px;
                  height: 88%;
                  width: 100%;
                  padding: 0 20px;
                  padding-top: 10px;
                "
              >
                <!-- <div class="process_time">
                <p>
                  <b>安全施工天数</b>
                  <span class="work_day">0</span>
                  <span class="work_day">1</span>
                  <span class="work_day">0</span>
                  <span class="work_day">7</span>
                  <span class="work_day">天</span>
                </p>
                <p>
                  <b>进度倒计时</b>
                  <span class="online">0</span>
                  <span class="online">8</span>
                  <span class="online">6</span>
                  <span class="online">4</span>
                  <span class="online">天</span>
                </p>
                </div>-->
                <div class="swiper" style="width: 100%">
                  <!-- <div class="line"></div> -->
                  <swiper :options="options" ref="mySwiper" class="mySwiper">
                    <swiper-slide v-for="(item, index) in swiperData" :key="index">
                      <div style="height: 100%">
                        <img
                          style="width: 60%; height: 50%"
                          class="swiperImg"
                          :src="item.swiperImg"
                        />
                        <p>{{ item.name }}</p>
                        <p class="finishData">
                          <span class="line"></span>
                          <img class="finish" src="./img/icon_finish.png" alt />
                        </p>
                        <p>
                          {{ item.time }}
                          <span
                            :style="{
                              color:
                                item.day > 0 ? 'green' : 'rgba(255,85,94,1)',
                            }"
                            v-if="item.day"
                          >
                            {{
                            item.day > 0
                            ? "提前:" + item.day + "天"
                            : "滞后:" + item.day * -1 + "天"
                            }}
                          </span>
                        </p>
                      </div>
                    </swiper-slide>
                    <!-- <swiper-slide>
                    <div style="height: 85%">
                      <img class="swiperImg" src="./img/leave1.png" />
                      <p>工程桩施工完成</p>
                      <p class="finishData">
                        <span class="line"></span>
                        <img class="finish" src="./img/icon_finish.png" alt />
                      </p>
                      <p>2020.7.15</p>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div style="height: 85%">
                      <img class="swiperImg" src="./img/leave1.png" />
                      <p>工程桩施工完成</p>
                      <p class="finishData">
                        <span class="line"></span>
                        <img class="finish" src="./img/icon_finish.png" alt />
                      </p>
                      <p>2020.7.15</p>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div style="height: 85%">
                      <img class="swiperImg" src="./img/leave1.png" />
                      <p>工程桩施工完成</p>
                      <p class="finishData">
                        <span class="line"></span>
                        <img class="finish" src="./img/icon_finish.png" alt />
                      </p>
                      <p>2020.7.15</p>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div style="height: 85%">
                      <img class="swiperImg" src="./img/leave1.png" />
                      <p>工程桩施工完成</p>
                      <p class="finishData">
                        <span class="line"></span>
                        <img class="finish" src="./img/icon_finish.png" alt />
                      </p>
                      <p>2020.7.15</p>
                    </div>
                    </swiper-slide>-->
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                  </swiper>
                </div>
              </div>
            </div>
          </section>

          <section
            style="height: 87%; padding: 20px"
            v-if="tabIndex == 1 || tabIndex == 2 || tabIndex == 3"
          >
            <!-- 轮播图 -->
            <section v-if="renderSettingData.contentType == '2'" style="height: 100%">
              <swiper :options="Ooptions" ref="mySwipers" class="mySwiper" style="height: 100%">
                <swiper-slide v-for="(item, index) in renderSettingData.fileUrl" :key="index">
                  <div style="height: 100%">
                    <img class="swiperImg" style="height: 100%; height: 100%" :src="item.url" alt />
                  </div>
                </swiper-slide>

                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
              <div style="left: 22px" class="swiper-button-prev" slot="button-prev"></div>
              <div style="right: 22px" class="swiper-button-next" slot="button-next"></div>
            </section>

            <!-- 文字 -->
            <p
              v-if="renderSettingData.contentType == '1'"
              style="height: 100%; padding: 0 20px"
            >{{ renderSettingData.contentText }}</p>
            <!-- 视频 -->
            <section v-if="renderSettingData.contentType == '4'" style="height: 100%">
              <video
                v-if="renderSettingData.fileUrl"
                style="width: 100%; height: 100%"
                controls="controls"
                autoplay="autoplay"
              >
                <source :src="renderSettingData.fileUrl[0].url" type="video/mp4" />
              </video>
            </section>
          </section>
          <!-- <section style="height: 100%; padding: 20px" v-if="tabIndex == 2">
            2
          </section>
          <section style="height: 100%; padding: 20px" v-if="tabIndex == 3">
            3
          </section>-->
        </div>
      </section>

      <section v-else style="width: 100%; height: 100%">
        <vedio-monitor @hideVedio="hideVedio"></vedio-monitor>
      </section>
    </boxTitleMoudle>
  </div>
</template>

<script>
import "./css/home.scss";
import vedioMonitor from "./vedioMonitor";
import boxTitleMoudle from "@/components/BaseBoxTitleMoudle.vue";
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      titleName: '蛇口渔港人车管理项目',
      timer: null,
      isShowVedio: false, //视频切换状态
      tab_li: ["工地", "项目预览", "宣传快讯", "通知公告"],
      tabIndex: "0",
      echartsOption: {},
      renderSettingData: [],
      count: "", //总天数
      hasNumber: [], //已施工天数
      residueNumber: [],
      swiperData: [],
      options: {
        loop: false, // true循环轮播;false不循环轮播
        autoplay: false, // true自动播放;false不自动播放
        notNextTick: true,
        // pagination: {
        //   el: ".swiper-pagination", // 分页器
        //   clickable: true,
        // },
        //pagination: this.projectMaterial ? "" : ".swiper-pagination",
        //pagination: ".swiper-pagination",
        slidesPerView: "5",
        observer: true,
        observeParents: true,
        initialSlide: 0,
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
        // prevButton: ".swiper-button-prev",
        // nextButton: ".swiper-button-next",
        onSlideChangeEnd: () => {
          //滑动之后回调函数
          //切换结束时，告诉我现在是第几个slide
          // if (this.organiZationImgIdList) {
          //   //console.log("onSlideChangeEnd", swiper.realIndex);
          //   //this.$emit("realIndex", swiper.realIndex);
          //   //swiper.realIndex = "0";
          // }
        },
      },
      Ooptions: {
        loop: false, // true循环轮播;false不循环轮播
        autoplay: false, // true自动播放;false不自动播放
        notNextTick: true,
        // pagination: {
        //   el: ".swiper-pagination", // 分页器
        //   clickable: true,
        // },
        //pagination: this.projectMaterial ? "" : ".swiper-pagination",
        //pagination: ".swiper-pagination",
        slidesPerView: "1",
        observer: true,
        observeParents: true,
        initialSlide: 0,
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
        // prevButton: ".swiper-button-prev",
        // nextButton: ".swiper-button-next",
        onSlideChangeEnd: () => {
          //滑动之后回调函数
          //切换结束时，告诉我现在是第几个slide
          // if (this.organiZationImgIdList) {
          //   //console.log("onSlideChangeEnd", swiper.realIndex);
          //   //this.$emit("realIndex", swiper.realIndex);
          //   //swiper.realIndex = "0";
          // }
        },
      },
    };
  },
  components: {
    vedioMonitor,
    boxTitleMoudle,
  },
  watch: {
    // picListData(val) {
    //   this.swiper.slideTo(0, 0, false);
    // },
  },
  mounted() {
    this.oauthtToken();
  },
  created() {
    this.getMilestoneConfig();
    this.getSettingData();
    this.queryProject();
  },
  methods: {
    //    第三方tkoen
    oauthtToken() {
      let params = {
        client_id: "12876df1012b4783adcf5651a5471edf",
        client_secret: "0c6733b0dd8448de8e4351d16d7ea459",
        grant_type: "client_credentials",
      };
      this.$api.queryCameraOauthtToken(params).then((res) => {
        localStorage.setItem("access_token", res.access_token);
      });
    },
    queryProject() {
      this.$api.queryProject().then(res => {
        if (res.code === 200) {
          console.log(res.data.projectName);
          this.titleName = res.data.projectName
        }
      })
    },
    // 看板移入
    addActive() {
      clearInterval(this.timer); // 清除定时器
      this.timer = null;
    },
    // 看板移出
    removeActive() {
      this.timer = setInterval(() => {
        this.siwperSettingData();
      }, 10000);
    },
    siwperSettingData() {
      this.tabIndex++;
      if (this.tabIndex == 4) this.tabIndex = 0;
      if (this.tabIndex == 0) return;
      console.log("测试数据", this.SettingData);
      if (typeof this.SettingData !== undefined && this.SettingData) {
        let data = this.SettingData[this.tabIndex - 1];
        this.renderSettingData = data;
      }
    },
    // 切换tab栏
    changeTab(ind) {
      this.tabIndex = ind;
      if (ind == 0) return;
      console.log("this.SettingData", this.SettingData);
      if (typeof this.SettingData !== undefined && this.SettingData) {
        let data = this.SettingData[ind - 1];
        this.renderSettingData = data;
      }

      console.log(this.renderSettingData, ind, "renderSettingData");
    },
    getMilestoneConfig() {
      this.$api.getMilestoneConfig().then((res) => {
        if (res.code == "200") {
          if (res.data.list && res.data.list.length > 0) {
            res.data.list.forEach((item) => {
              item.swiperImg = item.swiperImg
                ? this.picServer + item.swiperImg
                : require("./img/noPic.png");
            });
            this.swiperData = res.data.list;
          }

          this.hasNumber = res.data.hasNumber.toString().split("");

          this.count = res.data.count;
          this.residueNumber = res.data.residueNumber.toString().split("");
        }
      });
    },
    // 看板
    getSettingData() {
      this.$api
        .getSettingData()
        .then((res) => {
          if (res.code == "200") {
            console.log("看板调用方法成功，返回看板方法返回的数据", res);
            if (res.data && res.data.length > 0) {
              // let arr = [];
              res.data.forEach((item) => {
                item.fileUrl = item.fileUrl ? JSON.parse(item.fileUrl) : "";
                this.SettingData = res.data;
                let data = this.SettingData[1 - 1];
                this.renderSettingData = data;
              });

              console.log(this.renderSettingData, "renderSettingData");
            }
          }
        })
        .then(() => {
          this.timer = setInterval(() => {
            this.siwperSettingData();
          }, 10000);
        });
    },
    // 视频切换到图片
    hideVedio() {
      this.isShowVedio = false;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer); // 清除定时器
    this.timer = null;
  },
  computed: {
    picServer() {
      return this.$store.state.picServer;
    },
  },
};
</script>
<style lang="scss" scoped>
.flex_div {
  width: 100%;
  height: 65%;
}
.tab_li {
  p {
    b {
      margin-right: 4px;
    }
  }
}
.mySwiper {
  text-align: center;
  width: 100%;
}
/deep/.swiper-slide {
  color: rgba(82, 154, 255, 1);
  font-size: 12px;
}
/deep/.swiper-slide .swiperImg {
  // width: 80%;
  // height: 62%;
  border-radius: 2px;
}
.finish {
  width: 9%;
}
.finishData {
  position: relative;
  .line {
    position: absolute;
    width: 98%;
    left: 2%;
    top: 50%;
    display: block;
    width: 100%;
    height: 1px;
    // background: #fff;
    border: 1px dashed rgba(82, 154, 255, 0.2);
  }
}
/deep/.swiper-button-prev {
  left: 0px;
}
/deep/.swiper-button-next {
  right: 0px;
}
.box-count {
  width: 1.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #27313a;
  border-radius: 0.1875rem;
  font-size: 1.25rem;
  font-family: digital;
  font-weight: 500;
}
</style>
